// Onglets produits
(function() {
    const firstPtab = document.querySelector(".ptabs > .ptab");
    if (typeof firstPtab !== "undefined" && firstPtab !== null) {
        firstPtab.classList.add("active");
    }

    const firstPtabSection = document.querySelector(".product-tabs > .ptab-section");
    if (typeof firstPtabSection !== "undefined" && firstPtabSection !== null) {
        firstPtabSection.classList.add("active");
    }

    const ptabs = document.querySelectorAll(".ptabs > .ptab");
    for (const ptab of ptabs) {
        ptab.addEventListener("click", function() {
            if (this.classList.contains("active") || typeof this.dataset.ptab === "undefined" || this.dataset.ptab === "") return;

            const section = document.getElementById("ptab-sec-" + this.dataset.ptab);
            if (section === null) return;

            const currentSection = document.querySelector(".ptab-section.active");
            if (currentSection !== null) {
                currentSection.classList.remove("active");
            }
            section.classList.add("active");

            const currentTab = document.querySelector(".ptab.active");
            if (currentTab !== null) {
                currentTab.classList.remove("active");
            }
            this.classList.add("active");
        });
    }
}());

// Variables session pour pays & province
if (typeof sxp_custcountry === "undefined") {
    var sxp_custcountry = "";
}
if (typeof sxp_custprovince === "undefined") {
    var sxp_custprovince = "";
}
if (typeof sxp_askedlocation === "undefined") {
    var sxp_askedlocation = false;
}

(function() {
    const defaultCountry = "Canada";
    const defaultProvince = "Quebec";

    // Géolocation
    if (sxp_custcountry === "" && !sxp_askedlocation) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                const quebec = [[-74.6685791015625,45.00413665556814],[-71.4825439453125,45.01433117775016],[-71.48117065429688,45.05606124274415],[-71.41387939453125,45.124897768677265],[-71.38778686523438,45.1907479300741],[-71.38641357421875,45.22364447346731],[-71.28341674804688,45.28068450114256],[-71.23672485351562,45.23911861682938],[-71.136474609375,45.23138207178167],[-71.08291625976561,45.28841433167348],[-70.9716796875,45.31739181570158],[-70.90301513671875,45.22557897178979],[-70.82611083984375,45.22461173085719],[-70.8343505859375,45.25652199219273],[-70.80413818359375,45.29710913206083],[-70.80276489257812,45.39555704145539],[-70.77804565429688,45.41291242895992],[-70.65444946289061,45.36661954708626],[-70.61599731445312,45.38977072743874],[-70.6146240234375,45.42158812329091],[-70.70938110351562,45.51115891482306],[-70.65994262695312,45.54867850352087],[-70.67092895507812,45.56502536350451],[-70.55831909179688,45.651488335713594],[-70.45394897460938,45.69562905418698],[-70.3729248046875,45.731108281529785],[-70.40451049804686,45.78859428734741],[-70.27267456054688,45.86610644902819],[-70.21499633789062,45.94542053059529],[-70.28366088867188,45.97406038956237],[-70.26580810546875,45.99028307184292],[-70.29327392578125,46.01317758972909],[-70.25894165039062,46.04559527286162],[-70.27267456054688,46.077993943416985],[-70.23147583007812,46.08466189789014],[-70.21499633789062,46.14939437647686],[-70.26443481445311,46.193140876238004],[-70.0323486328125,46.40756396630067],[-69.97604370117186,46.69184147024343],[-69.21661376953125,47.43737696208075],[-69.06005859375,47.41043231312493],[-69.049072265625,47.29320230289773],[-68.55880737304688,47.418795921472714],[-68.37066650390625,47.5459446373605],[-68.37753295898436,47.90805777537145],[-68.115234375,47.91173983456231],[-68.11935424804688,47.99635490025392],[-67.61672973632812,47.99819281946772],[-67.60711669921875,47.92554522341879],[-67.37228393554686,47.843579330145474],[-67.24456787109375,47.88135501149263],[-67.23014831542969,47.88642038695251],[-67.21229553222656,47.87536802006419],[-67.17453002929688,47.88135501149263],[-67.1649169921875,47.89424772020999],[-67.15118408203125,47.89010398526447],[-67.13264465332031,47.897930761804965],[-67.13127136230469,47.912660308427654],[-67.10655212402344,47.91173983456231],[-67.07084655761719,47.920943836444415],[-67.05780029296875,47.933366641930355],[-67.00973510742188,47.91127959148981],[-66.98020935058594,47.89332691887659],[-66.95892333984374,47.892406101169264],[-66.94381713867188,47.901153208295646],[-66.95137023925781,47.90943857826743],[-66.96853637695312,47.916342040161155],[-66.96510314941406,47.9444066308325],[-66.94656372070312,47.954064687296885],[-66.94107055664062,47.971996289577056],[-66.89300537109375,47.989921667414194],[-66.79412841796875,47.98808345357488],[-66.68563842773436,48.00278733106708],[-66.44393920898436,48.08266633622704],[-65.54443359375,47.879512933970496],[-64.259033203125,48.268569112964336],[-63.87451171875,48.785151998043155],[-66.24755859375,49.95121990866204],[-60.380859375,49.96535590991311],[-57.0849609375,51.303145259199056],[-57.041015625,52.06600028274635],[-62.9296875,52.16045455774706],[-62.81982421875001,52.64306343665892],[-63.69873046874999,53.09402405506325],[-65.7861328125,52.348763181988105],[-66.95068359374999,54.29088164657006],[-63.19335937499999,54.648412502316695],[-64.5556640625,60.823494332539646],[-73.65234375,62.552856958572896],[-78.3544921875,62.66405506888221],[-79.013671875,58.74540696858028],[-79.95849609375,54.71192884840614],[-79.5684814453125,51.57194856482396],[-79.52041625976562,47.55938397557884],[-79.61311340332031,47.441556792248534],[-79.43595886230469,47.24427960201268],[-79.45106506347656,47.10845747289683],[-79.34188842773438,46.96947659374449],[-79.2169189453125,46.83248247851647],[-79.17778015136719,46.826845094695855],[-79.07821655273438,46.66687348356156],[-79.02259826660156,46.63529366744315],[-78.99856567382812,46.59190029349218],[-78.99513244628906,46.55083326736553],[-78.75892639160156,46.39099040126688],[-78.73420715332031,46.38672781370433],[-78.73077392578124,46.34455763640945],[-78.69094848632812,46.317058427362575],[-78.50212097167969,46.29429000516299],[-78.39637756347656,46.292866664344295],[-78.31466674804688,46.25109887580333],[-78.25355529785156,46.272936008641494],[-78.21372985839844,46.26866421051983],[-78.13751220703125,46.27246138084736],[-78.04756164550781,46.238752301105684],[-78.00361633300781,46.244925935797895],[-77.6898193359375,46.18078126223906],[-77.68089294433594,46.19694327530828],[-77.27920532226562,46.01222384063236],[-77.2943115234375,45.96403812284582],[-77.19474792480469,45.867062714815475],[-77.05192565917969,45.80870039713958],[-77.02033996582031,45.80678584211672],[-76.98944091796875,45.78620021958554],[-76.9379425048828,45.787636672581385],[-76.91253662109375,45.80487122128867],[-76.92420959472656,45.8488908518382],[-76.89949035644531,45.85128222573176],[-76.93038940429686,45.89000815866184],[-76.78001403808594,45.87232188259709],[-76.783447265625,45.78428489134373],[-76.77040100097656,45.731108281529785],[-76.72370910644531,45.719603972998634],[-76.69075012207031,45.68795490838444],[-76.71409606933594,45.66348654108304],[-76.67152404785156,45.62460302647399],[-76.67701721191406,45.58665360146695],[-76.65916442871094,45.558775655027816],[-76.60972595214844,45.53280788583923],[-76.3611602783203,45.45724086262233],[-76.24099731445312,45.47265128615832],[-76.13388061523438,45.51741391767134],[-75.97663879394531,45.47698470876219],[-75.87570190429688,45.38639510400971],[-75.81287384033203,45.37240823082044],[-75.70884704589844,45.42399780182692],[-75.68412780761719,45.45844495366187],[-75.57769775390625,45.47433654565603],[-75.42182922363281,45.519578948984524],[-75.31677246093749,45.546514592174674],[-75.22064208984375,45.58713413436411],[-75.12657165527344,45.57608083698816],[-75.01087188720703,45.600347177025895],[-74.94770050048828,45.64260800861499],[-74.63493347167969,45.63804729356092],[-74.38156127929688,45.565986795411405],[-74.4708251953125,45.30387083299528],[-74.31976318359375,45.18784438050534],[-74.6685791015625,45.00413665556814]];
                if (pointIsInsidePolygon([position.coords.longitude, position.coords.latitude], quebec)) {
                    sxp_custcountry = defaultCountry;
                    sxp_custprovince = defaultProvince;
                } else {
                    sxp_custcountry = defaultCountry;
                    sxp_custprovince = "";
                }
                sendCartAttr({
                    "attributes[clientcountry]": sxp_custcountry,
                    "attributes[clientprovince]": sxp_custprovince
                });
            }, function(error) {
                sxp_custcountry = defaultCountry;
                sxp_custprovince = defaultProvince;
                sendCartAttr({
                    "attributes[clientcountry]": sxp_custcountry,
                    "attributes[clientprovince]": sxp_custprovince
                });
            });
            sendCartAttr({"attributes[askedlocation]": "true"});
        }
    }

    if (sxp_custcountry === "") {
        sxp_custcountry = defaultCountry;
        sxp_custprovince = defaultProvince;
    }

    const countrySelect = document.querySelector("#cart-position #position_country");
    const provinceSelect = document.querySelector("#cart-position #position_province");
    if (countrySelect === null || provinceSelect === null) return;

    if (typeof countrySelect.dataset.default !== "undefined" && countrySelect.dataset.default !== "") {
        countrySelect.value = countrySelect.dataset.default;
        if (countrySelect.dataset.default !== "Canada") {
            provinceSelect.parentElement.parentElement.style.display = "none";
        }
    } else {
        countrySelect.value = "Canada";
    }

    const canadaProvinces = document.querySelector("#cart-position #position_country option[value='Canada']");
    if (canadaProvinces !== null && typeof canadaProvinces.dataset.provinces !== "undefined" && canadaProvinces.dataset.provinces !== "") {
        try {
            const provinces = JSON.parse(canadaProvinces.dataset.provinces);
            for (const province of provinces) {
                const el = document.createElement("option");
                el.value = province[0];
                el.innerText = province[1];
                provinceSelect.appendChild(el);
            }
        } catch (err) {}
    }

    if (typeof provinceSelect.dataset.default !== "undefined" && provinceSelect.dataset.default !== "") {
        provinceSelect.value = provinceSelect.dataset.default;
    } else {
        provinceSelect.value = "Quebec";
    }

    countrySelect.addEventListener("change", function(event) {
        let newProvince = "";
        if (event.target.value === "---") event.target.value = "";
        let attrs = { "attributes[clientcountry]": event.target.value };
        if (event.target.value === "Canada") {
            newProvince = "Quebec";
            attrs["attributes[clientprovince]"] = newProvince;
            provinceSelect.value = newProvince;
            provinceSelect.parentElement.parentElement.style.display = "block";
        } else {
            provinceSelect.parentElement.parentElement.style.display = "none";
        }
        sxp_custcountry = event.target.value;
        if (newProvince !== "") {
            sxp_custprovince = newProvince;
        }
        sendCartAttr(attrs);
    });

    provinceSelect.addEventListener("change", function(event) {
        sxp_custprovince = event.target.value;
        sendCartAttr({"attributes[clientprovince]": event.target.value});
    });

    function sendCartAttr(data) {
        $.ajax({
            type: "POST",
            url: "/cart.js",
            data: data,
            success: function(response) {},
            dataType: "json"
        });
    }

    // https://github.com/substack/point-in-polygon
    function pointIsInsidePolygon(point, vs) {
        const x = point[0], y = point[1];

        let inside = false;
        for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
            const xi = vs[i][0], yi = vs[i][1];
            const xj = vs[j][0], yj = vs[j][1];
            const intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }
}());

// Écofrais
(function() {
    const cartSubmitBtns = document.querySelectorAll("button[name='checkout'][type='submit']");
    if (cartSubmitBtns.length < 1) return;

    const ecofrais = {
        qc: {
            class_857m: 47524149625068,
            class_847m: 47524149657836,
            class_846m: 47524149690604,
            class_845m: 47524149723372,
            class_855m: 47524149756140,
            class_853m: 47524149788908,
            class_850m: 47524149821676,
            class_851m: 47524149854444,
            class_852m: 47524149887212,
            class_856m: 47524149919980,
            class_854m: 47524149952748,
            class_849m: 47524149985516,
            class_848m: 47524150018284,
            class_900m: 47695681814764
        },
        /*on: {
            class_14700m: 43343969911036,
            class_14701m: 43343969943804,
            class_14702m: 43343969976572,
            class_14703m: 43343970009340,
            class_14704m: 43343970042108,
            class_14705m: 43343970074876,
            class_14706m: 43343970107644,
            class_14707m: 43343970140412,
            class_14708m: 43343970173180,
            class_14709m: 43343970205948,
            class_14710m: 43343970238716,
            class_14711m: 43343970271484,
            class_14712m: 43343970304252,
            class_14713m: 43343970337020
        }*/
    };
    var ecofraisProductIds = [];
    for (const key1 in ecofrais) {
        for (const key2 in ecofrais[key1]) {
            ecofraisProductIds.push(ecofrais[key1][key2]);
        }
    }

    Shopify.moveAlong = function() {
        if (Shopify.queue.length) {
            const request = Shopify.queue.shift();
            switch (request.action) {
                case "add":
                    try {
                        Shopify.addItem(request.id, request.quantity, Shopify.moveAlong);
                    } catch (error) {
                        //
                    }
                    break;
                case "edit":
                    try {
                        Shopify.changeItem(request.id, request.quantity, Shopify.moveAlong);
                    } catch (error) {
                        //
                    }
                    break;
                case "remove":
                    try {
                        Shopify.removeItem(request.id, Shopify.moveAlong);
                    } catch (error) {
                        //
                    }
                    break;
                default:
                    //
            }
        } else {
            document.location.href = '/checkout';
        }
    };

    for (const cartSubmitBtn of cartSubmitBtns) {
        cartSubmitBtn.addEventListener("click", function(event) {
            event.preventDefault();

            const cartPositionElem = document.querySelector("#cart-position");
            if (cartPositionElem && cartPositionElem.classList.contains("err")) {
                cartPositionElem.classList.remove("err");
            }

            if (cartPositionElem && (sxp_custcountry === "" || (sxp_custcountry === "Canada" && sxp_custprovince === ""))) {
                // Demander de remplir la position
                cartPositionElem.classList.add("err");
                $("html, body").animate({
                    scrollTop: $("#cart-position").offset().top
                }, 500);
                return;
            }

            if (sxp_custcountry === "" || (sxp_custcountry === "Canada" && sxp_custprovince === "Quebec")) {
                const prov = sxp_custprovince === "Ontario" ? "on" : "qc";
                // Vérifier si les écofrais sont présents et les ajouter s'il en manque
                $.ajax({
                    type: "GET",
                    url: "/cart?view=list_ecofrais",
                    success: function(data) {
                        // Ajouter ou enlever les écofrais
                        try {
                            const cartList = JSON.parse(data);
                            if (cartList.items.length < 1) return;

                            const ecofraisQty = initEcofraisQtyList(ecofraisProductIds);
                            const currentEcofraisQty = initEcofraisQtyList(ecofraisProductIds);
                            for (const item of cartList.items) {
                                if (
                                    prov === 'qc'
                                    && item.ecofrais !== ""
                                    && typeof ecofrais[prov][item.ecofrais] !== "undefined"
                                ) {
                                    ecofraisQty[ecofrais[prov][item.ecofrais]] += item.quantity;
                                } else if (
                                    prov === 'on'
                                    && item.ecofrais_on !== ""
                                    && typeof ecofrais[prov][item.ecofrais_on] !== "undefined"
                                ) {
                                    ecofraisQty[ecofrais[prov][item.ecofrais_on]] += item.quantity;
                                } else if (ecofraisProductIds.includes(item.id)) {
                                    currentEcofraisQty[item.id]++;
                                }
                            }

                            Shopify.queue = [];
                            $.each(ecofraisQty, function(key, value) {
                                if (value < 1 && currentEcofraisQty[key] > 0) {
                                    // Enlever
                                    Shopify.queue.push({
                                        id: key,
                                        quantity: value,
                                        action: "remove"
                                    });
                                } else if (value > 0 && currentEcofraisQty[key] > 0) {
                                    // Modifier s'il est différent
                                    Shopify.queue.push({
                                        id: key,
                                        quantity: value,
                                        action: "edit"
                                    });
                                } else if (value > 0) {
                                    // Ajouter
                                    Shopify.queue.push({
                                        id: key,
                                        quantity: value,
                                        action: "add"
                                    });
                                }
                            });
                            Shopify.moveAlong();
                        } catch (error) {
                            document.location.href = '/checkout';
                        }
                    }
                });
            } else {
                // Vérifier si des écofrais sont présents et les enlever s'il y en a
                $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    success: function(data) {
                        if (data.items.length < 1) return;

                        try {
                            Shopify.queue = [];
                            for (const item of data.items) {
                                if (ecofraisProductIds.includes(item.id)) {
                                    // Enlever
                                    Shopify.queue.push({
                                        id: item.id,
                                        quantity: 0,
                                        action: "remove"
                                    });
                                }
                            }
                            Shopify.moveAlong();
                        } catch (error) {
                            document.location.href = '/checkout';
                        }
                    }
                });
            }
        });
    }

    function initEcofraisQtyList(ecofraisProductIds) {
        var list = {};
        for (const ecofraisProductId of ecofraisProductIds) {
            list[ecofraisProductId] = 0;
        }
        return list;
    }
}());

// Images de marque et écofrais dans la liste des produits après un filtre
(function() {
    const productList = document.querySelector(".boost-pfs-filter-products");
    if (!productList) return;

    let timer = null;
    const observer = new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
            if (mutation.type === "childList") {
                if (timer !== null) clearTimeout(timer);
                timer = setTimeout(checkProductList, 1000);
                break;
            }
        }
    });
    observer.observe(productList, { childList: true });

    function checkProductList() {
        const products = productList.querySelectorAll(".boost-pfs-filter-product-item");
        if (products.length < 1) return;

        for (const product of products) {
            if (!product.classList.contains("sxp-checked") && !product.querySelector(".productitem--marque")) {
                const link = product.querySelector(".boost-pfs-filter-product-item-image-link");
                if (!link || typeof link.href === "undefined" || link.href === "") continue;

                $.ajax({
                    type: "GET",
                    url: link.href + "?view=marque_img_eco",
                    success: function(response) {
                        try {
                            var marque_eco = JSON.parse(response);
                            if (typeof marque_eco.marque_img !== "undefined" && marque_eco.marque_img !== null && marque_eco.marque_img !== "") {
                                $(product).find(".boost-pfs-filter-product-bottom-inner").prepend(marque_eco.marque_img);
                            }
                            if (typeof marque_eco.price !== "undefined" && marque_eco.price !== null && marque_eco.price !== "") {
                                $(product).find('.boost-pfs-filter-product-item-regular-price, .boost-pfs-filter-product-item-sale-price').html(marque_eco.price);
                            }
                            if (typeof marque_eco.compare_price !== "undefined" && marque_eco.compare_price !== null && marque_eco.compare_price !== "") {
                                $(product).find('.boost-pfs-filter-product-item-price s').html(marque_eco.compare_price);
                            }
                            if (typeof marque_eco.eco_price !== "undefined" && marque_eco.eco_price !== null && marque_eco.eco_price !== "") {
                                $(product).find('.boost-pfs-filter-product-item-price').append(marque_eco.eco_price);
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    },
                    finally: function() {
                        product.classList.add("sxp-checked");
                    }
                });
            }
        }

        timer = null;
    }
}());
